import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { useI18n } from "../i18n";
import { WHATSAPP_URL, MEDIA } from "../constants";

export default function Hero() {
  const { t, lang } = useI18n();

  return (
    <section
      id="top"
      className="relative w-full min-h-[100vh] flex items-end overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={MEDIA.hero_interior}
          alt="TINTA interior"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d0c0b]/85 via-[#0d0c0b]/55 to-[#0d0c0b]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d0c0b]/80 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-16 pb-20 md:pb-28 pt-32">
        <div className="flex items-center gap-3 mb-6 animate-fade-up" style={{ animationDelay: "0.1s" }}>
          <div className="divider-gold" />
          <span className="overline">{t.hero.overline}</span>
        </div>

        <h1
          className="font-serif-display text-[#f4f0eb] text-5xl sm:text-7xl md:text-8xl lg:text-9xl font-light leading-[0.95] tracking-tight max-w-5xl animate-fade-up"
          style={{ animationDelay: "0.2s" }}
          data-testid="hero-title"
        >
          {t.hero.title_1}
          <br />
          <span className="italic text-[#d4af37]">{t.hero.title_2}</span>
        </h1>

        <p
          className="mt-8 text-[#a39e97] text-base md:text-lg max-w-xl leading-relaxed animate-fade-up"
          style={{ animationDelay: "0.35s" }}
          data-testid="hero-subtitle"
        >
          {t.hero.subtitle}
        </p>

        <div
          className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 animate-fade-up"
          style={{ animationDelay: "0.5s" }}
        >
          <a
            href={WHATSAPP_URL(
              lang === "es"
                ? "Hola TINTA, me gustaría hacer una reserva."
                : "Hi TINTA, I'd like to make a reservation."
            )}
            target="_blank"
            rel="noopener noreferrer"
            className="tinta-btn-primary"
            data-testid="hero-reserve-button"
          >
            {t.hero.cta_reserve}
            <ArrowRight size={16} />
          </a>

          <a
            href="#menu"
            className="tinta-btn-ghost"
            data-testid="hero-menu-button"
          >
            {t.hero.cta_menu}
          </a>
        </div>

        <div
          className="mt-10 inline-flex items-center gap-3 text-xs uppercase tracking-[0.28em] text-[#a39e97] animate-fade-up"
          style={{ animationDelay: "0.65s" }}
          data-testid="hero-open-now"
        >
          <Sparkles size={14} className="text-[#d4af37]" />
          <span>{t.hero.open_now}</span>
        </div>
      </div>
    </section>
  );
}
